<template>
  <div class="header">
    <div class="header-one">
      <div class="brand">
        <template v-if="catName.length > 0">
          <el-tag v-for="item in catName"
                  :key="item.cat_id"
                  color="#FF7D00"
                  class="keyWords">
            {{item.name}}
          </el-tag>
          <el-tag v-if="omit"
                  color="#FF7D00"
                  class="keyWords">
            ...
          </el-tag>
        </template>
        <span> > </span>
        <el-tag v-if="brandName"
                class="keyWords"
                color="#69C0FF"
                v-html="brandName">
        </el-tag>
        <span v-if="brandName"> > </span>
        <span v-if="postWord"
              class="postWord"
              v-html="postWord">
          <!-- {{$t('baseInfo.postKeyWordLabel')+postWord}} -->
        </span>
        <span>|</span>
        <span class="follow"> <span>
            <i class="iconfont icon-heart iconBox"
               v-show="isFollow"
               @click="followClick(1)"></i>
            <i class="iconfont icon-heart-fill red iconBox"
               v-show="!isFollow"
               @click="followClick(0)"></i>
          </span>+{{$t('mainHead.follow')}}</span>
      </div>
      <div class="
              time-pick">
        <!-- <el-checkbox-group v-model="checkList"
                           :min="1"
                           @change="handlePlantChange">
          <el-checkbox label="weibo">{{$t('mainHead.platList_weibo')}}</el-checkbox>
          <el-checkbox label="douyin">{{$t('mainHead.platList_douyin')}}</el-checkbox>
          <el-checkbox label="xhs">{{$t('mainHead.platList_xhs')}}</el-checkbox>
        </el-checkbox-group> -->
        <span style="margin:0 6px 0 12px">{{$t('headSearch.month')}}：</span>
        <el-select v-model="ts"
                   size="small"
                   :disabled="isDisabled"
                   placeholder="请选择"
                   @change="changeTs"
                   style="width:120px">
          <el-option v-for="(item,index) in timeList"
                     :key="index"
                     :label="item"
                     :value="item">
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="header-two">
      <!-- <div style="width:100%"> -->
      <el-tabs v-model="editableTabsValue"
               type="card"
               @tab-click="handleTabClick">
        <el-tab-pane :key="item.name"
                     v-for="(item) in editableTabsList"
                     :label="item.title"
                     :name="item.name">

        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { setMarked, getSearchMarked, getCatName } from '@/api/public'
import { getWordTs } from '@/api/amazon'
import { getUrlParams, setUrlParams, build_ts } from '@/utils'
export default {
  data() {
    return {
      ts: this.$store.state.user.ts,
      editableTabs: [
        {
          title: this.$t('mainHead.tabs_trend'),
          name: 'PublicTrendList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_category'),
          name: 'PublicCategoryList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_brand'),
          name: 'PublicBrandList',
          isShow: true,
        },
        {
          title: this.$t('mainHead.tabs_commodity'),
          name: 'PublicCommodityList',
          isShow: true,
        },
      ],
      postWord: this.$store.state.user.selectedKeyWards,
      catName: this.$store.state.user.cat_name,
      brandName: this.$store.state.user.brand_name,
      editableTabsValue: 'PublicTrendList',
      ActivedTabArr: [],
      isFollow: true,

      isDisabled: false,
      timeList: [],

      cid: '',
      omit: false,
    }
  },
  computed: {
    editableTabsList: function () {
      return this.editableTabs.filter(function (item) {
        return item.isShow //返回isShow=true的项，添加到activeUsers数组
      })
    },
  },
  methods: {
    followClick(val) {
      var reg = /^["|'](.*)["|']$/g
      let param = {
        category_id: getUrlParams('cid'),
        func: val,
        platform: getUrlParams('plat'),
        type: 'word',
        word: getUrlParams('word_source')
          ? getUrlParams('word_source')
          : this.$store.state.user.selectedKeyWards.replace(reg, '$1'),
      }
      setMarked(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.isFollow = !this.isFollow
            this.$message.success('设置成功')
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch((e) => {
          this.$message.error(e.data.error_msg.msg)
        })
    },
    getMarked() {
      getSearchMarked({
        category_id: getUrlParams('cid'),
        plat: getUrlParams('plat'),
        word: getUrlParams('word_source')
          ? getUrlParams('word_source')
          : this.$store.state.user.selectedKeyWards.replace(
            /^["|'](.*)["|']$/g,
            '$1'
          ),
      })
        .then((res) => {
          if (res.status == 'ok') {
            if (res.result.data.monitor_flag == '1') {
              this.isFollow = false
            } else {
              this.isFollow = true
            }
          } else {
            this.$message.error('请求失败')
          }
        })
        .catch((e) => {
          // this.$message.success('删除失败')
        })
    },
    changeActivedTabArr() {
      var self = this
      for (var i = 0; i < self.editableTabs.length; i++) {
        Vue.set(self.editableTabs[i], 'isShow', true)
      }
      if (this.ActivedTabArr && this.ActivedTabArr.length > 0) {
        this.ActivedTabArr.forEach(function (item) {
          Vue.set(self.editableTabs[item], 'isShow', false)
        })
      }
    },
    /*
     type:查询类型  id:通过id精确查询，name：通过名称模糊查询
    */
    handleTabClick(tab, event) {
      localStorage.setItem('publicActivedTab', tab.name)
      this.$store.dispatch('user/changePublicActivedTab', tab.name)
    },
    getTs() {
      getWordTs().then((res) => {
        if (res.status == 'ok') {
          this.timeList = build_ts(res.result.ts, res.result.ts_min)
          if (!this.$route.query.publicTs) {
            this.ts = res.result.ts
          }
        }
      })
    },
    changeTs(val) {
      this.$router.push({
        name: 'publicDetail',
        query: {
          cid: this.$route.query.cid,
          word: this.$route.query.word_source,
          publicTs: val,
          plat: this.$route.query.plat,
          monitor_flag: this.$route.query.monitor_flag,
        },
      })
    },
  },
  watch: {
    '$store.state.user.cat_name': {
      handler(newVal, oldVal) {
        this.catName = newVal
      },
    },
    '$store.state.user.brand_name': {
      handler(newVal, oldVal) {
        this.brandName = newVal
      },
    },
    '$store.state.user.selectedKeyWards': {
      handler(newVal, oldVal) {
        this.postWord = newVal
      },
    },
    '$store.state.user.publicActivedTab': {
      handler(newVal, oldVal) {
        this.editableTabsValue = newVal
      },
    },
    '$route.query': {
      handler(query) {
        let language = localStorage.getItem('language')
        if (language == 'zh') {
          this.postWord = query.word
        } else if (language == 'en' && query.word_source) {
          this.postWord = query.word_source
        } else {
          if (localStorage.getItem('word')) {
            this.postWord = localStorage.getItem('word')
          }
        }
        this.cid = query.cid
        const params = {
          plat: 'gamazon',
          cat: this.cid,
          site_lang: this.$i18n.locale,
        }
        getCatName(params).then((res) => {
          if (res.result.data.length > 3) {
            this.catName = res.result.data.slice(0, 3)
            this.omit = true
          } else {
            this.catName = res.result.data
            this.omit = false
          }
        })
        if (query.publicTs) {
          this.ts = query.publicTs
        }
        this.getMarked()
      },
    },
    '$store.state.user.publicActivedTabArr': {
      handler(newVal) {
        this.ActivedTabArr = newVal
        this.changeActivedTabArr()
      },
    },
    // '$store.state.user.ActivedTabArr': {
    //   handler(newVal, oldVal) {
    //     this.ActivedTabArr = newVal
    //     this.changeActivedTabArr()
    //   },
    // },
  },
  mounted() {
    this.getMarked()
  },
  created() {
    const routeQuery = this.$route.query
    let language = localStorage.getItem('language')
    if (language == 'zh') {
      this.postWord = routeQuery.word
    } else if (language == 'en' && routeQuery.word_source) {
      this.postWord = routeQuery.word_source
    } else {
      if (localStorage.getItem('word')) {
        this.postWord = localStorage.getItem('word')
      }
    }
    this.cid = routeQuery.cid
    const params = {
      plat: 'gamazon',
      cat: this.cid,
      site_lang: this.$i18n.locale,
    }
    getCatName(params).then((res) => {
      if (res.result.data.length > 3) {
        this.catName = res.result.data.slice(0, 3)
        this.omit = true
      } else {
        this.catName = res.result.data
        this.omit = false
      }
    })
    if (routeQuery.publicTs) {
      this.ts = routeQuery.publicTs
    }

    this.$eventBus.$on('publicSummaryDataLoading', (val) => {
      //防止频繁切换时间发送请求
      this.isDisabled = val
    })
    this.getTs()
    // if (
    //   localStorage.getItem('ebayActivedTabArr') &&
    //   localStorage.getItem('ebayActivedTabArr').length > 0
    // ) {
    //   this.ActivedTabArr = localStorage.getItem('ebayActivedTabArr')
    // }
  },
}
</script>

<style scoped lang='less'>
.keyWords {
  color: #fff;
}
.postword {
  color: #252525;
}
.follow {
  color: #85868a;
}
.iconBox {
  cursor: pointer;
  margin-right: 4px;
}
.lb {
  display: inline-block;
}
.red {
  color: #ff7875;
}
</style>
